/**
 * Spend per supplier, one row per supplier name. Two supplier records with
 * the same title (e.g. a duplicate "J R Gowans Fishmongers") would give the
 * pie two slices with the same id, which React warns about and the reader
 * can't tell apart; they are added together instead (untitled suppliers
 * share one "Unknown supplier" row for the same reason).
 *
 * @param {object[]} bySuppliers — `{ supplier, supplierName, totalAmount }`
 * @returns {{ key: string, supplierName: string, totalAmount: number }[]}
 */
export const mergeSpendBySupplierName = (bySuppliers = []) => {
  const rows = new Map()
  for (const item of bySuppliers || []) {
    const name = String(item?.supplierName || '').trim()
    const mergeKey = name.toLowerCase()
    const amount = Number(item?.totalAmount) || 0
    const row = rows.get(mergeKey)
    if (row) {
      row.totalAmount += amount
      continue
    }
    rows.set(mergeKey, {
      key: String(item?.supplier ?? mergeKey),
      supplierName: name || 'Unknown supplier',
      totalAmount: amount,
    })
  }
  return [...rows.values()]
}
